export const useLanguages = (t: any) => {
  return [
    { name: 'Українська', code: 'uk' },
    { name: 'English', code: 'en' },
    { name: 'Русский', code: 'ru' },
    // { name: `${t('German')}`, code: 'de' },
  ]
}
